var map = {
	"./bg001.png": "./src/EGRContent/Story/KaagRaRoti/images/bg001.png",
	"./bg01.png": "./src/EGRContent/Story/KaagRaRoti/images/bg01.png",
	"./bg02.png": "./src/EGRContent/Story/KaagRaRoti/images/bg02.png",
	"./bg03.png": "./src/EGRContent/Story/KaagRaRoti/images/bg03.png",
	"./bg04.png": "./src/EGRContent/Story/KaagRaRoti/images/bg04.png",
	"./bg05.png": "./src/EGRContent/Story/KaagRaRoti/images/bg05.png",
	"./bg_green.png": "./src/EGRContent/Story/KaagRaRoti/images/bg_green.png",
	"./cover_page.gif": "./src/EGRContent/Story/KaagRaRoti/images/cover_page.gif",
	"./cover_page.jpg": "./src/EGRContent/Story/KaagRaRoti/images/cover_page.jpg",
	"./cover_page.png": "./src/EGRContent/Story/KaagRaRoti/images/cover_page.png",
	"./cover_page_new01.gif": "./src/EGRContent/Story/KaagRaRoti/images/cover_page_new01.gif",
	"./crow_drop_stone.png": "./src/EGRContent/Story/KaagRaRoti/images/crow_drop_stone.png",
	"./crow_dropping_roti_land.gif": "./src/EGRContent/Story/KaagRaRoti/images/crow_dropping_roti_land.gif",
	"./crow_dropping_roti_land.png": "./src/EGRContent/Story/KaagRaRoti/images/crow_dropping_roti_land.png",
	"./crow_dropping_roti_river.gif": "./src/EGRContent/Story/KaagRaRoti/images/crow_dropping_roti_river.gif",
	"./crow_dropping_stone.gif": "./src/EGRContent/Story/KaagRaRoti/images/crow_dropping_stone.gif",
	"./crow_dropping_stone.png": "./src/EGRContent/Story/KaagRaRoti/images/crow_dropping_stone.png",
	"./crow_eat_roti.gif": "./src/EGRContent/Story/KaagRaRoti/images/crow_eat_roti.gif",
	"./crow_eat_roti.png": "./src/EGRContent/Story/KaagRaRoti/images/crow_eat_roti.png",
	"./crow_eat_rotinew.gif": "./src/EGRContent/Story/KaagRaRoti/images/crow_eat_rotinew.gif",
	"./crow_fly_to_home.gif": "./src/EGRContent/Story/KaagRaRoti/images/crow_fly_to_home.gif",
	"./crow_fly_to_river.gif": "./src/EGRContent/Story/KaagRaRoti/images/crow_fly_to_river.gif",
	"./crow_going_to_river.gif": "./src/EGRContent/Story/KaagRaRoti/images/crow_going_to_river.gif",
	"./crow_pick_roti.gif": "./src/EGRContent/Story/KaagRaRoti/images/crow_pick_roti.gif",
	"./crow_pick_roti_foot.gif": "./src/EGRContent/Story/KaagRaRoti/images/crow_pick_roti_foot.gif",
	"./crow_pick_roti_foot1.gif": "./src/EGRContent/Story/KaagRaRoti/images/crow_pick_roti_foot1.gif",
	"./crow_roti01.gif": "./src/EGRContent/Story/KaagRaRoti/images/crow_roti01.gif",
	"./crow_roti01.png": "./src/EGRContent/Story/KaagRaRoti/images/crow_roti01.png",
	"./crow_roti02.gif": "./src/EGRContent/Story/KaagRaRoti/images/crow_roti02.gif",
	"./crow_roti_feet.png": "./src/EGRContent/Story/KaagRaRoti/images/crow_roti_feet.png",
	"./crow_roti_taking_from_river01.png": "./src/EGRContent/Story/KaagRaRoti/images/crow_roti_taking_from_river01.png",
	"./crow_roti_taking_from_river02.png": "./src/EGRContent/Story/KaagRaRoti/images/crow_roti_taking_from_river02.png",
	"./crow_take_bite_roti.png": "./src/EGRContent/Story/KaagRaRoti/images/crow_take_bite_roti.png",
	"./crow_try_to_pick_roti.gif": "./src/EGRContent/Story/KaagRaRoti/images/crow_try_to_pick_roti.gif",
	"./crow_try_to_pick_roti.png": "./src/EGRContent/Story/KaagRaRoti/images/crow_try_to_pick_roti.png",
	"./grass.png": "./src/EGRContent/Story/KaagRaRoti/images/grass.png",
	"./page15.png": "./src/EGRContent/Story/KaagRaRoti/images/page15.png",
	"./roti_01.png": "./src/EGRContent/Story/KaagRaRoti/images/roti_01.png",
	"./roti_02.png": "./src/EGRContent/Story/KaagRaRoti/images/roti_02.png",
	"./roti_03.png": "./src/EGRContent/Story/KaagRaRoti/images/roti_03.png",
	"./speaking_crow.png": "./src/EGRContent/Story/KaagRaRoti/images/speaking_crow.png",
	"./speaking_crow3.gif": "./src/EGRContent/Story/KaagRaRoti/images/speaking_crow3.gif",
	"./standing_crow.png": "./src/EGRContent/Story/KaagRaRoti/images/standing_crow.png",
	"./stone.png": "./src/EGRContent/Story/KaagRaRoti/images/stone.png",
	"./thumnails.png": "./src/EGRContent/Story/KaagRaRoti/images/thumnails.png",
	"./water_wave01.png": "./src/EGRContent/Story/KaagRaRoti/images/water_wave01.png",
	"./water_wave02.png": "./src/EGRContent/Story/KaagRaRoti/images/water_wave02.png",
	"./water_wave03.png": "./src/EGRContent/Story/KaagRaRoti/images/water_wave03.png"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "./src/EGRContent/Story/KaagRaRoti/images sync recursive ^\\.\\/.*$";